'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// ../es-errors/type.js
// module id = 41
// module chunks = 0